/* eslint-disable */
import U from './../lib-utils'
import abstractLayer from './abstractLayer'
import Mustache from './../../mustache/mustache'
import tpl_main from '!!raw-loader!./templates/ruller/calibration-layer.html'
import events from './lib-events'
import { central_data } from './lib-central-data'
require('./style/calibrator-layer.scss')

function rullerCalibrationLayer() {
  return (
    rullerCalibrationLayer.is(this) ? this.init : rullerCalibrationLayer.F
  ).apply(this, Array.prototype.slice.call(arguments))
}

var P = rullerCalibrationLayer.leu_extend(abstractLayer).prototype

P.verticalRuller = null
P.horizontalRuller = null
P.top = null
P.bottom = null
P.left = null
P.right = null
P.handle = null
P.tool = null

P.vPos = null
P.hPos = null
P.vSize = null
P.hSize = null

P._getCancelIcon = function () {
  return require('!!raw-loader!@/svg/ruller/cross.svg').default.replace(
    '<id-attribute>',
    'ruller-calibration-layer-icon-cross',
  )
}

P._getApplyIcon = function () {
  return require('!!raw-loader!@/svg/ruller/apply.svg').default.replace(
    '<id-attribute>',
    'ruller-calibration-layer-icon-apply',
  )
}

P.on_init = function () {
  var d = document.createElement('div')
  this.getApplyIcon = this._getApplyIcon.bindTo(this)
  this.getCancelIcon = this._getCancelIcon.bindTo(this)
  d.innerHTML = Mustache.render(tpl_main, this)
  this.verticalRuller = d.children.item(0)
  this.horizontalRuller = d.children.item(1)
  this.tool = d.children.item(2)
  this.top = this.verticalRuller.children.item(0)
  this.bottom = this.verticalRuller.children.item(1)
  this.left = this.horizontalRuller.children.item(0)
  this.right = this.horizontalRuller.children.item(1)
  this.verticalRuller.style.display = 'none'
  this.horizontalRuller.style.display = 'none'
  this.tool.style.display = 'none'
  this.enabled = false
  this.vPos = { x: 50, y: 20 }
  this.hPos = { x: 50, y: 20 }
  this.vSize = 50
  this.hSize = 50
  this.init_handlers()
  return this
}

P.init_handlers = function () {
  this.verticalRuller.addEventListener(
    'mousedown',
    this.vertical_mouse_down.bindTo(this),
  )
  this.horizontalRuller.addEventListener(
    'mousedown',
    this.horizontal_mouse_down.bindTo(this),
  )
  this.left.addEventListener('mousedown', this.h_left_mouse_down.bindTo(this))
  this.right.addEventListener('mousedown', this.h_right_mouse_down.bindTo(this))
  this.top.addEventListener('mousedown', this.h_top_mouse_down.bindTo(this))
  this.bottom.addEventListener('mousedown', this.h_bot_mouse_down.bindTo(this))
  //wheel translation is too glitchy, may be better to disable it
  this.verticalRuller.addEventListener('wheel', this.v_on_wheel.bindTo(this))
  this.horizontalRuller.addEventListener('wheel', this.h_on_wheel.bindTo(this))
  // buttons processor
  this.tool.addEventListener('click', this.on_command.bindTo(this))
}

//<editor-fold defaultstate="collapsed" desc="commands">
P.upuntildata = function (node, datasetKey, stopNode) {
  if (node === stopNode || node === null) {
    return null
  }
  if (node.dataset[datasetKey] !== void 0) {
    return node
  }
  return this.upuntildata(node.parentElement, datasetKey, stopNode)
}
P.on_command = function (e) {
  var target = this.upuntildata(e.target, 'command', this.tool)
  if (target) {
    var command = U.NEString(target.dataset.command, null)
    if (command) {
      var fn = ['on_command_', command.toLowerCase()].join('')
      if (U.isCallable(this[fn])) {
        this[fn](e)
      }
    }
  }
}
P.on_command_cancel = function (e) {
  e.stopPropagation()
  this.enabled = false
  this.draw()
  central_data().lem.run(events._SHOW_DATA_LAYER)
}

P.on_command_apply = function (e) {
  this.triggerApply()
  this.on_command_cancel(e)
}
//</editor-fold>
//<editor-fold defaultstate="collapsed" desc="triggers">
P.triggerUpdate = function () {
  central_data().lem.run(
    events._RULLER_CALIBRATION_INTERMEDATE,
    this.getEventData(),
  )
}

P.triggerCommit = function () {
  central_data().lem.run(events._RULLER_CALIBRATION_COMMIT, this.getEventData())
}

P.triggerApply = function () {
  central_data().lem.run(events._RULLER_CALIBRATION_APPLY, this.getEventData())
}
//</editor-fold>
//<editor-fold defaultstate="collapsed" desc="wheel event (translate to layout)">
P.v_on_wheel = function (e) {
  this.layout.on_wheel({
    deltaX: event.deltaX,
    deltaY: event.deltaY,
    offsetX: event.offsetX + this.verticalRuller.offsetLeft,
    offsetY: event.offsetY + this.verticalRuller.offsetTop,
  })
}
P.h_on_wheel = function (e) {
  this.layout.on_wheel({
    deltaX: event.deltaX,
    deltaY: event.deltaY,
    offsetX: event.offsetX + this.horizontalRuller.offsetLeft,
    offsetY: event.offsetY + this.horizontalRuller.offsetTop,
  })
}
//</editor-fold>

P.getEventData = function () {
  return {
    size: {
      h: this.hSize,
      v: this.vSize,
    },
    pos: {
      v: {
        x: this.vPos.x,
        y: this.vPos.y,
      },
      h: {
        x: this.hPos.x,
        y: this.hPos.y,
      },
    },
  }
}

//<editor-fold defaultstate="collapsed" desc="vertical ruller drag">
P.vertical_mouse_down = function (e) {
  var cx = this.vPos.x
  var cy = this.vPos.y
  var translated = this.layout.calculator.translate_image_pcu(
    cx,
    cy,
    this.layout.layout_width,
    this.layout.layout_height,
    this.layout.scale,
    this.layout.center_x,
    this.layout.center_y,
  )
  this._verticalDragStart = {
    px: translated.viewport.px,
    pcu: {
      x: cx,
      y: cy,
    },
    e: {
      x: e.pageX,
      y: e.pageY,
    },
  }
  document.addEventListener('mouseup', this.vertical_mouse_abort.bindTo(this))
  document.addEventListener(
    'mousemove',
    this.vertical_mouse_waitstart.bindTo(this),
  )
}

P.vertical_mouse_abort = function () {
  document.removeEventListener(
    'mouseup',
    this.vertical_mouse_abort.bindTo(this),
  )
  document.removeEventListener(
    'mousemove',
    this.vertical_mouse_waitstart.bindTo(this),
  )
}

P.vertical_mouse_waitstart = function (e) {
  var dx = e.pageX - this._verticalDragStart.e.x
  var dy = e.pageY - this._verticalDragStart.e.y
  var dt = Math.sqrt(dx * dx + dy * dy)
  if (dt > 5) {
    this.vertical_mouse_abort()
    document.addEventListener(
      'mousemove',
      this._vertical_while_drag.bindTo(this),
    )
    document.addEventListener(
      'mouseup',
      this._vertical_commit_drag.bindTo(this),
    )
    this._vertical_while_drag(e)
  }
}

P._vertical_while_drag = function (e) {
  var dxpx = e.pageX - this._verticalDragStart.e.x
  var dypx = e.pageY - this._verticalDragStart.e.y
  var offset = this.layout.calculator.translate_viewport_px_to_image_pcu(
    dxpx,
    dypx,
    this.layout.scale,
  )
  this.vPos.x = this._verticalDragStart.pcu.x + offset.x
  this.vPos.y = this._verticalDragStart.pcu.y + offset.y
  this.triggerUpdate()
  this.drawVertical()
}
P._vertical_commit_drag = function (e) {
  this._vertical_while_drag(e)
  document.removeEventListener(
    'mousemove',
    this._vertical_while_drag.bindTo(this),
  )
  document.removeEventListener(
    'mouseup',
    this._vertical_commit_drag.bindTo(this),
  )
  this.vertical_mouse_abort()
  this.triggerCommit()
}
//</editor-fold>
//<editor-fold defaultstate="collapsed" desc="horizontal ruller drag">
P.horizontal_mouse_down = function (e) {
  var cx = this.hPos.x
  var cy = this.hPos.y
  var translated = this.layout.calculator.translate_image_pcu(
    cx,
    cy,
    this.layout.layout_width,
    this.layout.layout_height,
    this.layout.scale,
    this.layout.center_x,
    this.layout.center_y,
  )
  this._horizontalDragStart = {
    px: translated.viewport.px,
    pcu: {
      x: cx,
      y: cy,
    },
    e: {
      x: e.pageX,
      y: e.pageY,
    },
  }
  document.addEventListener('mouseup', this.horizontal_mouse_abort.bindTo(this))
  document.addEventListener(
    'mousemove',
    this.horizontal_mouse_waitstart.bindTo(this),
  )
}

P.horizontal_mouse_abort = function () {
  document.removeEventListener(
    'mouseup',
    this.horizontal_mouse_abort.bindTo(this),
  )
  document.removeEventListener(
    'mousemove',
    this.horizontal_mouse_waitstart.bindTo(this),
  )
}

P.horizontal_mouse_waitstart = function (e) {
  var dx = e.pageX - this._horizontalDragStart.e.x
  var dy = e.pageY - this._horizontalDragStart.e.y
  var dt = Math.sqrt(dx * dx + dy * dy)
  if (dt > 5) {
    this.horizontal_mouse_abort()
    document.addEventListener(
      'mousemove',
      this._horizontal_while_drag.bindTo(this),
    )
    document.addEventListener(
      'mouseup',
      this._horizontal_commit_drag.bindTo(this),
    )
    this._horizontal_while_drag(e)
  }
}

P._horizontal_while_drag = function (e) {
  var dxpx = e.pageX - this._horizontalDragStart.e.x
  var dypx = e.pageY - this._horizontalDragStart.e.y
  var offset = this.layout.calculator.translate_viewport_px_to_image_pcu(
    dxpx,
    dypx,
    this.layout.scale,
  )
  this.hPos.x = this._horizontalDragStart.pcu.x + offset.x
  this.hPos.y = this._horizontalDragStart.pcu.y + offset.y
  this.drawHorizontal()
  this.triggerUpdate()
}
P._horizontal_commit_drag = function (e) {
  this._horizontal_while_drag(e)
  document.removeEventListener(
    'mousemove',
    this._horizontal_while_drag.bindTo(this),
  )
  document.removeEventListener(
    'mouseup',
    this._horizontal_commit_drag.bindTo(this),
  )
  this.horizontal_mouse_abort()
  this.triggerCommit()
}

//</editor-fold>

//<editor-fold defaultstate="collapsed" desc="size handlers">
//<editor-fold defaultstate="collapsed" desc="horizontal size handlers">
//<editor-fold defaultstate="collapsed" desc="left size handler">
P.h_left_mouse_down = function (e) {
  e.stopPropagation()
  var cx = this.hPos.x
  var cy = this.hPos.y
  var cs = this.hSize
  var translated = this.layout.calculator.translate_image_pcu(
    cx,
    cy,
    this.layout.layout_width,
    this.layout.layout_height,
    this.layout.scale,
    this.layout.center_x,
    this.layout.center_y,
  )
  this._sizeStart = {
    size: cs,
    px: translated.viewport.px,
    pcu: {
      x: cx,
      y: cy,
    },
    e: {
      x: e.pageX,
      y: e.pageY,
    },
  }
  document.addEventListener('mouseup', this.h_left_mouse_abort.bindTo(this))
  document.addEventListener(
    'mousemove',
    this.h_left_mouse_waitstart.bindTo(this),
  )
}
P.h_left_mouse_abort = function () {
  document.removeEventListener('mouseup', this.h_left_mouse_abort.bindTo(this))
  document.removeEventListener(
    'mousemove',
    this.h_left_mouse_waitstart.bindTo(this),
  )
}
P.h_left_mouse_waitstart = function (e) {
  var dx = e.pageX - this._sizeStart.e.x
  if (Math.abs(dx) > 5) {
    this.h_left_mouse_abort()
    document.addEventListener(
      'mousemove',
      this._h_left_mouse_whiledrag.bindTo(this),
    )
    document.addEventListener(
      'mouseup',
      this._h_left_mouse_commit_drag.bindTo(this),
    )
    this._h_left_mouse_whiledrag(e)
  }
}

P._h_left_mouse_whiledrag = function (e) {
  var dxpx = e.pageX - this._sizeStart.e.x
  var offset = this.layout.calculator.translate_viewport_px_to_image_pcu(
    dxpx,
    dxpx,
    this.layout.scale,
  )
  //left point - so, size must be changed to same value with negation
  this.hSize = this._sizeStart.size + -1 * offset.x
  //position calculated in depends of size, but its only 1/2 of change
  this.hPos.x = this._sizeStart.pcu.x + offset.x / 2.0
  this.drawHorizontal()
  this.triggerUpdate()
}

P._h_left_mouse_commit_drag = function (e) {
  this._h_left_mouse_whiledrag(e)
  document.removeEventListener(
    'mousemove',
    this._h_left_mouse_whiledrag.bindTo(this),
  )
  document.removeEventListener(
    'mouseup',
    this._h_left_mouse_commit_drag.bindTo(this),
  )
  this.h_left_mouse_abort()
  this.triggerCommit()
}
//</editor-fold>
//<editor-fold defaultstate="collapsed" desc="right size handler">
P.h_right_mouse_down = function (e) {
  e.stopPropagation()
  var cx = this.hPos.x
  var cy = this.hPos.y
  var cs = this.hSize
  var translated = this.layout.calculator.translate_image_pcu(
    cx,
    cy,
    this.layout.layout_width,
    this.layout.layout_height,
    this.layout.scale,
    this.layout.center_x,
    this.layout.center_y,
  )
  this._sizeStart = {
    size: cs,
    px: translated.viewport.px,
    pcu: {
      x: cx,
      y: cy,
    },
    e: {
      x: e.pageX,
      y: e.pageY,
    },
  }
  document.addEventListener('mouseup', this.h_right_mouse_abort.bindTo(this))
  document.addEventListener(
    'mousemove',
    this.h_right_mouse_waitstart.bindTo(this),
  )
}
P.h_right_mouse_abort = function () {
  document.removeEventListener('mouseup', this.h_right_mouse_abort.bindTo(this))
  document.removeEventListener(
    'mousemove',
    this.h_right_mouse_waitstart.bindTo(this),
  )
}
P.h_right_mouse_waitstart = function (e) {
  var dx = e.pageX - this._sizeStart.e.x
  if (Math.abs(dx) > 5) {
    this.h_right_mouse_abort()
    document.addEventListener(
      'mousemove',
      this._h_right_mouse_whiledrag.bindTo(this),
    )
    document.addEventListener(
      'mouseup',
      this._h_right_mouse_commit_drag.bindTo(this),
    )
    this._h_right_mouse_whiledrag(e)
  }
}

P._h_right_mouse_whiledrag = function (e) {
  var dxpx = e.pageX - this._sizeStart.e.x
  var offset = this.layout.calculator.translate_viewport_px_to_image_pcu(
    dxpx,
    dxpx,
    this.layout.scale,
  )
  //right point - so, size must be changed to same value
  this.hSize = this._sizeStart.size + offset.x
  //position calculated in depends of size, but its only 1/2 of change
  this.hPos.x = this._sizeStart.pcu.x + offset.x / 2.0
  this.drawHorizontal()
  this.triggerUpdate()
}

P._h_right_mouse_commit_drag = function (e) {
  this._h_right_mouse_whiledrag(e)
  document.removeEventListener(
    'mousemove',
    this._h_right_mouse_whiledrag.bindTo(this),
  )
  document.removeEventListener(
    'mouseup',
    this._h_right_mouse_commit_drag.bindTo(this),
  )
  this.h_right_mouse_abort()
  this.triggerCommit()
}
//</editor-fold>
//</editor-fold>
//<editor-fold defaultstate="collapsed" desc="vertical size handlers">
//<editor-fold defaultstate="collapsed" desc="top size handler">
P.h_top_mouse_down = function (e) {
  e.stopPropagation()
  var cx = this.vPos.x
  var cy = this.vPos.y
  var cs = this.vSize
  var translated = this.layout.calculator.translate_image_pcu(
    cx,
    cy,
    this.layout.layout_width,
    this.layout.layout_height,
    this.layout.scale,
    this.layout.center_x,
    this.layout.center_y,
  )
  this._sizeStart = {
    size: cs,
    px: translated.viewport.px,
    pcu: {
      x: cx,
      y: cy,
    },
    e: {
      x: e.pageX,
      y: e.pageY,
    },
  }
  document.addEventListener('mouseup', this.h_top_mouse_abort.bindTo(this))
  document.addEventListener(
    'mousemove',
    this.h_top_mouse_waitstart.bindTo(this),
  )
}
P.h_top_mouse_abort = function () {
  document.removeEventListener('mouseup', this.h_top_mouse_abort.bindTo(this))
  document.removeEventListener(
    'mousemove',
    this.h_top_mouse_waitstart.bindTo(this),
  )
}
P.h_top_mouse_waitstart = function (e) {
  var dy = e.pageY - this._sizeStart.e.y
  if (Math.abs(dy) > 5) {
    this.h_top_mouse_abort()
    document.addEventListener(
      'mousemove',
      this._h_top_mouse_whiledrag.bindTo(this),
    )
    document.addEventListener(
      'mouseup',
      this._h_top_mouse_commit_drag.bindTo(this),
    )
    this._h_top_mouse_whiledrag(e)
  }
}

P._h_top_mouse_whiledrag = function (e) {
  var dypx = e.pageY - this._sizeStart.e.y
  var offset = this.layout.calculator.translate_viewport_px_to_image_pcu(
    dypx,
    dypx,
    this.layout.scale,
  )
  //top point - so, size must be changed to same value with negation
  this.vSize = this._sizeStart.size + offset.y * -1
  //position calculated in depends of size, but its only 1/2 of change
  this.vPos.y = this._sizeStart.pcu.y + offset.y / 2.0
  this.drawVertical()
  this.triggerUpdate()
}

P._h_top_mouse_commit_drag = function (e) {
  this._h_top_mouse_whiledrag(e)
  document.removeEventListener(
    'mousemove',
    this._h_top_mouse_whiledrag.bindTo(this),
  )
  document.removeEventListener(
    'mouseup',
    this._h_top_mouse_commit_drag.bindTo(this),
  )
  this.h_top_mouse_abort()
  this.triggerCommit()
}
//</editor-fold>
//<editor-fold defaultstate="collapsed" desc="bottom size handler">
P.h_bot_mouse_down = function (e) {
  e.stopPropagation()
  var cx = this.vPos.x
  var cy = this.vPos.y
  var cs = this.vSize
  var translated = this.layout.calculator.translate_image_pcu(
    cx,
    cy,
    this.layout.layout_width,
    this.layout.layout_height,
    this.layout.scale,
    this.layout.center_x,
    this.layout.center_y,
  )
  this._sizeStart = {
    size: cs,
    px: translated.viewport.px,
    pcu: {
      x: cx,
      y: cy,
    },
    e: {
      x: e.pageX,
      y: e.pageY,
    },
  }
  document.addEventListener('mouseup', this.h_bot_mouse_abort.bindTo(this))
  document.addEventListener(
    'mousemove',
    this.h_bot_mouse_waitstart.bindTo(this),
  )
}
P.h_bot_mouse_abort = function () {
  document.removeEventListener('mouseup', this.h_bot_mouse_abort.bindTo(this))
  document.removeEventListener(
    'mousemove',
    this.h_bot_mouse_waitstart.bindTo(this),
  )
}
P.h_bot_mouse_waitstart = function (e) {
  var dy = e.pageY - this._sizeStart.e.y
  if (Math.abs(dy) > 5) {
    this.h_bot_mouse_abort()
    document.addEventListener(
      'mousemove',
      this._h_bot_mouse_whiledrag.bindTo(this),
    )
    document.addEventListener(
      'mouseup',
      this._h_bot_mouse_commit_drag.bindTo(this),
    )
    this._h_bot_mouse_whiledrag(e)
  }
}

P._h_bot_mouse_whiledrag = function (e) {
  var dypx = e.pageY - this._sizeStart.e.y
  var offset = this.layout.calculator.translate_viewport_px_to_image_pcu(
    dypx,
    dypx,
    this.layout.scale,
  )
  //bottom point - so, size must be changed to same value
  this.vSize = this._sizeStart.size + offset.y
  //position calculated in depends of size, but its only 1/2 of change
  this.vPos.y = this._sizeStart.pcu.y + offset.y / 2.0
  this.drawVertical()
  this.triggerUpdate()
}

P._h_bot_mouse_commit_drag = function (e) {
  this._h_bot_mouse_whiledrag(e)
  document.removeEventListener(
    'mousemove',
    this._h_bot_mouse_whiledrag.bindTo(this),
  )
  document.removeEventListener(
    'mouseup',
    this._h_bot_mouse_commit_drag.bindTo(this),
  )
  this.h_bot_mouse_abort()
  this.triggerCommit()
}
//</editor-fold>
//</editor-fold>
//</editor-fold>

P.attachHandleToLayout = function (x) {
  x.appendChild(this.verticalRuller)
  x.appendChild(this.horizontalRuller)
  x.appendChild(this.tool)
}

/**
 * Вызывается менеджером
 * @returns {background_layer}
 */
P.clear = function () {
  if (this.enabled) {
  }
  return this
}

/**
 * Вызывается менеджером после ресайза
 * @returns {background_layer}
 */
P.resize = function () {
  if (this.enabled) {
  }
  return this
}

P.runCalibrationSequence = function (cs) {
  cs = U.safeObject(cs)
  this.hPos = {
    x: U.FloatOr(cs.hposx, 50),
    y: U.FloatOr(cs.hposy, 50),
  }
  this.vPos = {
    x: U.FloatOr(cs.vposx, 50),
    y: U.FloatOr(cs.vposy, 50),
  }
  this.hSize = U.floatMoreOr(cs.hsize, 0, 50)
  this.vSize = U.floatMoreOr(cs.vsize, 0, 50)
  this.horizontalRuller.style.display = ''
  this.horizontalRuller.style.display = ''
  this.tool.style.display = ''
  this.enabled = true
  this.draw()
}

P.on_hover = function (event) {}

P.on_data_ready = function () {}

P.on_image_ready = function () {}

P.drawHorizontal = function () {
  var hTranslated = this.layout.calculator.translate_image_pcu(
    this.hPos.x,
    this.hPos.y,
    this.layout.layout_width,
    this.layout.layout_height,
    this.layout.scale,
    this.layout.center_x,
    this.layout.center_y,
  )

  var hCenter_x = hTranslated.viewport.px.x
  var hCenter_y = hTranslated.viewport.px.y
  var hSize =
    this.layout.calculation_result.image.pc1x * this.layout.scale * this.hSize
  // высота - константа
  // смещение всегда на половину высоты (в пикселях, не расчетная)
  this.horizontalRuller.style.top = [(hCenter_y - 12).toFixed(3), 'px'].join('')
  this.horizontalRuller.style.height = '24px'
  this.horizontalRuller.style.left = [
    (hCenter_x - hSize / 2).toFixed(3),
    'px',
  ].join('')
  this.horizontalRuller.style.width = [hSize.toFixed(3), 'px'].join('')
}

P.drawVertical = function () {
  var vTranslated = this.layout.calculator.translate_image_pcu(
    this.vPos.x,
    this.vPos.y,
    this.layout.layout_width,
    this.layout.layout_height,
    this.layout.scale,
    this.layout.center_x,
    this.layout.center_y,
  )
  var vCenter_x = vTranslated.viewport.px.x
  var vCenter_y = vTranslated.viewport.px.y
  var vSize =
    this.layout.calculation_result.image.pc1y * this.layout.scale * this.vSize
  // ширина - константа
  // смещение всегда на половину ширины (в пикселях, не расчетная)
  this.verticalRuller.style.left = [(vCenter_x - 12).toFixed(3), 'px'].join('')
  this.verticalRuller.style.width = '24px'
  this.verticalRuller.style.top = [
    (vCenter_y - vSize / 2).toFixed(3),
    'px',
  ].join('')
  this.verticalRuller.style.height = [vSize.toFixed(3), 'px'].join('')
}

/**
 * Вызывается менеджером, внутри animationFrame. Менеджер сам проверит корректность входных данных
 * @returns {rullerCalibrationLayer}
 */
P.draw = function () {
  if (!this.enabled) {
    this.horizontalRuller.style.display = 'none'
    this.verticalRuller.style.display = 'none'
    this.tool.style.display = 'none'
    return
  }
  this.drawHorizontal()
  this.drawVertical()
  this.horizontalRuller.style.display = 'block'
  this.verticalRuller.style.display = 'block'
  this.tool.style.display = ''
}

export default rullerCalibrationLayer
